module.exports = __webpack_public_path__ + "static/media/mintic.b95a8fb5.png";